
export function escapeHtml(text: string) {
  return text.replace(/\&/gi, '&amp;')
    .replace(/\</gi, '&lt;')
    .replace(/\>/gi, '&gt;')
    .replace(/"/gi, '&quot;')
    .replace(/'/gi, '&#039;');
}
